export default __webpack_public_path__ + "static/media/190629_190332_IMG_9257 (1).520c5bef.jpg";